import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import axios from "axios";
import { Fetch } from "../services/dataservice";
import { connect } from 'react-redux';
import { signin, customer } from "../redux/action/login.action";
//const jwt = require('jsonwebtoken');

function MemberLogin({ history, loginStatus, loginInfo }) {
    const [credentials, setCredentials] = useState({
        email: null,
        password: null
    });

    const handleChange = (e, property) => {
        setCredentials({ ...credentials, [property]: e.target.value });
    };

    const handleAuthenticate = async () => {
        try {            
            let customerId = await Fetch(`/CustomerValidate/Login`, "post", credentials);
            if (customerId > 0) {
                // alert("Login Successfully.");                
                
                // const token = jwt.sign({customerId}, "jwsSecret", {
                //     expiresIn: 300,
                // })

                axios
                    .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/Customer/GetById/` + customerId)
                    .then((response) => {
                        const item = response.data;

                        const cust = [{ custId: customerId, fName: item.firstName }];
                        loginInfo(cust);
                    });
                
                loginStatus(true); 
                                                              
                history.push("/member");
                // history.push({
                //     pathname: '/member',
                //     state: customerId
                // })               
            } else {
                alert("You have entered an invalid email or password.");
            }
        } 
        catch (ex) {            
            alert("Error...");
        }
    };

    return (
        <div>
            <div className="int-container">
                <div className="container">
                    <div className="form-container">
                        <div className="form-group">
                            <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Member Login</h3>
                        </div>
                        <div className="form-group">
                            <input type="email" placeholder="Enter Email" onChange={(e) => handleChange(e, "email")} className="form-control" />
                        </div>
                        <div className="form-group">
                            <input type="password" placeholder="Enter Password" onChange={(e) => handleChange(e, "password")} className="form-control" />
                        </div>
                        <div className="form-group">
                            <button className="btn btn-block btn-primary" onClick={handleAuthenticate}>Submit</button>
                        </div>
                        <div className="form-group text-center">
                            <Link to="/forgot-password" style={{ color: "#fff", lineHeight: "35px" }}>Forgot Password</Link>&nbsp;&nbsp;|&nbsp;&nbsp;
                            <Link to="/member-registration" style={{ color: "#fff", lineHeight: "35px" }}>New Member Registration</Link>                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const mapDispatchToProps = dispatch => ({
    loginStatus: (IsLogin) => dispatch(signin(IsLogin)),    
    loginInfo: (CustInfo) => dispatch(customer(CustInfo))   
})

export default connect(null, mapDispatchToProps)(withRouter(MemberLogin));